var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"address-wrapper"},[_c('van-address-edit',{attrs:{"area-list":_vm.areaList,"search-result":_vm.searchResult,"area-columns-placeholder":['请选择', '请选择', '请选择'],"save-button-text":"确认收货信息"},on:{"save":_vm.onSave}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d9c6ad8","hasScoped":true,"transformToRequire":{"video":["app","poster"],"source":"app","img":"app","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/pages/tabs/Mine/AddressInfo.vue
// module id = null
// module chunks = 